import React from "react";
import {
  FiUsers,
  FiBookOpen,
  FiDollarSign,
  FiTrendingUp,
} from "react-icons/fi";

const InfoCads = () => {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      {/* Card 1 */}
      <div className="bg-white rounded-2xl shadow-md hover:scale-[1.02] transition-all duration-300 border border-gray-100 p-4 md:p-5 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400">
            Total Users
          </p>
          <h3 className="mt-2 text-2xl font-semibold text-gray-900">1,245</h3>
          <p className="mt-1 text-xs text-emerald-600">+4.5% vs last month</p>
        </div>
        <div className="p-3 rounded-full bg-indigo-50">
          <FiUsers className="w-6 h-6 text-indigo-600" />
        </div>
      </div>

      {/* Card 2 */}
      <div className="bg-white rounded-2xl shadow-md hover:scale-[1.02] transition-all duration-300 border border-gray-100 p-4 md:p-5 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400">
            Active Courses
          </p>
          <h3 className="mt-2 text-2xl font-semibold text-gray-900">32</h3>
          <p className="mt-1 text-xs text-emerald-600">+3 new this week</p>
        </div>
        <div className="p-3 rounded-full bg-emerald-50">
          <FiBookOpen className="w-6 h-6 text-emerald-600" />
        </div>
      </div>

      {/* Card 3 */}
      <div className="bg-white rounded-2xl shadow-md hover:scale-[1.02] transition-all duration-300 border border-gray-100 p-4 md:p-5 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400">
            Revenue (Monthly)
          </p>
          <h3 className="mt-2 text-2xl font-semibold text-gray-900">
            ₹ 85,400
          </h3>
          <p className="mt-1 text-xs text-rose-600">-2.1% vs last month</p>
        </div>
        <div className="p-3 rounded-full bg-rose-50">
          <FiDollarSign className="w-6 h-6 text-rose-600" />
        </div>
      </div>

      {/* Card 4 */}
      <div className="bg-white rounded-2xl shadow-md hover:scale-[1.02] transition-all duration-300 border border-gray-100 p-4 md:p-5 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400">
            Growth
          </p>
          <h3 className="mt-2 text-2xl font-semibold text-gray-900">18.3%</h3>
          <p className="mt-1 text-xs text-emerald-600">Steady upward trend</p>
        </div>
        <div className="p-3 rounded-full bg-amber-50">
          <FiTrendingUp className="w-6 h-6 text-amber-500" />
        </div>
      </div>
    </section>
  );
};

export default InfoCads;
